import React from 'react';
import Typewriter from 'typewriter-effect';
import './TopContent.css';

import Tilt from 'react-tilt';

import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";

const TopContent = () => {

    return(
        <div className="topContent">
            <AnimationOnScroll animateIn="animate__fadeIn" className="topContent-text">
                <h1>Mateusz Hus</h1>
                <h3><Typewriter 
                    options={{
                        loop: true
                    }}
                    onInit={ (type) => {
                        type.typeString('Front-End developer')
                        .pauseFor(2000)
                        .deleteAll()
                        .typeString('Back-End developer')
                        .pauseFor(2000)
                        .deleteAll()
                        .typeString('Ui/Ux designer')
                        .pauseFor(2000)
                        .deleteAll()
                        .typeString('Mówią mi: DeveLOpe')
                        .pauseFor(2000)
                        .deleteAll()
                        .typeString('Podpisuje się jako: Dvl-designs')
                        .pauseFor(2000)
                        .deleteAll()
                        .start();
                    } }
                /></h3>
                <p>Jestem inżynierem oprogramowania z Kielc, który specjalizuje się w budowie aplikacji webowych. Niedawno skończyłem studia. Obecnie pochłaniają mnie kursy programistyczne.</p>
                <a className="btnCont" href="/assets/download/cv.pdf" download target="_blank">CV - PDF</a>
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="animate__fadeIn">
                <Tilt className="topContent-img">
                    <img alt="fig" src="/assets/images/illus-webdesign.png" />
                </Tilt>
            </AnimationOnScroll>
        </div>
    );
}

export default TopContent;